<template>
  <el-drawer
    title="默认banner详情"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="40%"
    withHeader="false"
  >
    <div class="title-box">基本信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="banner名称">{{ info.name }}</el-descriptions-item>
      <el-descriptions-item label="选用模板">
        {{ info.adTemplateName }}
      </el-descriptions-item>
      <el-descriptions-item label="组内位置">{{ info.slotKey || '-' }}</el-descriptions-item>
    </el-descriptions>

    <div class="title-box">banner预览</div>
    <div class="preview-box">
      <div v-if="info.adTemplateName === '1*4 banner位'" class="preview">
        <div>
          <img :src="info.marketImgUrl" alt="" />
        </div>
        <div>
          <img :src="info.imgUrl" alt="" />
        </div>
        <div>{{ info.marketText }}</div>
      </div>
      <div v-else class="preview">
        <img :src="info.imgUrl" alt="" />
      </div>
    </div>

    <div class="title-box">页面跳转</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="跳转页面">{{ info.pageUrl || '-' }}</el-descriptions-item>
      <el-descriptions-item label="跳转类型">
        {{ getPageUrlType(info.pageUrlType) }}
      </el-descriptions-item>
      <el-descriptions-item v-if="info.pageUrlType === 3" label="APPID">
        {{ info.appId || '-' }}
      </el-descriptions-item>
      <el-descriptions-item v-if="info.pageUrlType === 3" label="账号原始ID">
        {{ info.appletOriginalId || '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="展示渠道">
        {{ getDisplayChannels(info.displayChannel) }}
      </el-descriptions-item>
    </el-descriptions>

    <div class="title-box">其他信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="创建人">{{ info.createUserName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ info.createTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="审核人">{{ info.auditUserName || '-' }}</el-descriptions-item>
      <el-descriptions-item label="审核时间">{{ info.auditTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="最新编辑人">{{
        info.updateUserName || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="编辑时间">{{ info.updateTime || '-' }}</el-descriptions-item>
      <el-descriptions-item label="广告状态">{{
        getBannerStatus(info.status)
      }}</el-descriptions-item>
      <el-descriptions-item v-if="info.refuseReason" label="审核拒绝原因">
        {{ info.refuseReason }}
      </el-descriptions-item>
    </el-descriptions>
  </el-drawer>
</template>

<script>
  import { getBannerDetail } from '@/api/bottomBannerDefault'

  export default {
    name: 'BannerDetail',
    data() {
      return {
        drawer: false,
        info: {}
      }
    },
    methods: {
      init(id) {
        this.bannerId = id
        this.getDetailFetch(id)
      },
      getDetailFetch(id) {
        this.$loading()
        getBannerDetail(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.info = data
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.info = {}
        this.drawer = false
      },
      getTemplateName(id) {
        return this.templateNames[id] || '-'
      },
      getPageUrlType(type) {
        const types = {
          1: '乘客端内部页面',
          2: '外部链接',
          3: '其他小程序（仅在微信小程序生效）'
        }
        return types[type] || '-'
      },
      getDisplayChannels(channels) {
        if (!channels) return '-'

        const channelMap = {
          1: '微信小程序',
          2: 'APP',
          3: '云闪付',
          4: '支付宝小程序'
        }

        const displayChannels = []
        channels.split(',').forEach((channel) => {
          if (channelMap[channel]) {
            displayChannels.push(channelMap[channel])
          }
        })

        return displayChannels.length > 0 ? displayChannels.join('、') : '-'
      },
      getBannerStatus(status) {
        const statusMap = {
          0: '草稿',
          1: '待审核',
          2: '未通过',
          3: '未开始',
          4: '进行中',
          5: '下架'
        }
        return statusMap[status] || '-'
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .preview-box {
    margin: 0 40px 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
  }

  .preview-text {
    color: #f56c6c;
    margin-bottom: 15px;

    p {
      margin: 5px 0;
    }
  }

  .banner-images {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .image-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      p {
        margin-bottom: 10px;
        font-weight: 500;
      }

      .market-text {
        padding: 10px;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        min-width: 150px;
        text-align: center;
      }
    }
  }
  .preview {
    //display: flex;
    //flex-direction: column;
    //align-items: center;
  }
</style>
